import { Injectable } from "@angular/core";
import { Router, UrlTree } from "@angular/router";
import { RoleService } from "../services/role.service";

@Injectable({ providedIn: 'root' })
export class TesteeGuard {
    constructor(private roleService: RoleService, private router: Router) { }

    // [AUTH-26] Redirect instead of returning false: non-testee users land on their home page,
    // everyone else on login.
    canActivate(): boolean | UrlTree {
        if (this.roleService.isTestee()) {
            return true;
        }

        return this.router.createUrlTree(this.roleService.isUser() ? ['/app'] : ['/auth/login']);
    }
}
